export enum ThermalMeterDetailField {
  Flange = 'flange',
  Orientation = 'orientation',
  Flowrate = 'flowrate',
  LayLength = 'layLength',
  DiameterNominal = 'diameterNominal',
  Resistance = 'resistance',
  InstallationPosition = 'installationPosition',
  ThermalMeasurementType = 'thermalMeasurementType',
}
